import React from 'react';

import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import { OutlineButton } from 'components/Button';
import styles from './contact.module.scss';

import contact from 'assets/icons/contact.svg';
import mail from 'assets/icons/mail.svg';
import { Helmet } from 'react-helmet';

const PROGRAMS = [
  { id: 'cap', name: 'CAP' },
  { id: 'csbg', name: 'CSBG' },
  { id: 'liheap', name: 'LIHEAP' },
  { id: 'weatherization', name: 'Weatherization' },
  { id: 'victim-support', name: 'Victim Services' },
  { id: 'head-start', name: 'Head Start' },
  { id: 'nutrition', name: 'Nutrition' },
  { id: 'shelter', name: 'Shelter' },
  { id: 'transportation', name: 'Transportation' },
  { id: 'housing-assistance', name: 'Housing Assistance' },
  { id: 'youth-programs', name: 'Youth Programs' },
  { id: 'other', name: 'Other' },
];

function ContactUs(props) {
  return (
    <section className={styles.contactBg}>
      <Container>
        <Row>
          <Col md={9}>
            <div className="py-md-5">
              <Helmet>
                <title>Contact Us - CAP60</title>
                <meta
                  name="description"
                  content="Are you looking for a solution to data management? CAP60 is the best one for easily managing large data. Contact us Now!."
                />
                <meta name="keywords" content="contact us, cap60 contact" />
              </Helmet>
              <h1 className="pt-5 mb-3">Contact Us</h1>
              <p className="font-s1">
                Stay In Touch: We Would Love to Hear From You to offer you the
                best.
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={9}>
            <div className={[styles.bgDust, 'p-4 mb-5'].join(' ')}>
              <h3 className="mb-3">Drop us a line</h3>
              <p className="font-s1">
                Fill in the below form and we will give you a quote.
              </p>

              <Form action="https://formspree.io/f/moqykjgj" method="POST">
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>*Email:</Form.Label>
                      <Form.Control
                        id="email"
                        type="email"
                        name="email"
                        placeholder=""
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>*Your Name:</Form.Label>
                      <Form.Control
                        id="name"
                        name="name"
                        placeholder=""
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>*Agency Name:</Form.Label>
                      <Form.Control
                        id="agencyname"
                        name="agencyname"
                        placeholder=""
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>*Agency State:</Form.Label>
                      <Form.Control
                        id="agencystate"
                        name="agencystate"
                        placeholder=""
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    {PROGRAMS.map((p) => (
                      <label className="custom-checkbox mr-2" key={p.id}>
                        {p.name}
                        <input type="checkbox" name={p.id} />
                        <span className="checkmark"></span>
                      </label>
                    ))}
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>*Contact Number:</Form.Label>
                      <Form.Control
                        id="contactnumber"
                        name="contactnumber"
                        placeholder=""
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        id="message"
                        name="message"
                        as="textarea"
                        rows={5}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="my-3">
                  <label className="custom-checkbox">
                    I would like to receive emails from CAP60
                    <input
                      type="checkbox"
                      id="allowemails"
                      name="allowemails"
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <OutlineButton type="submit">Send Message</OutlineButton>
              </Form>
            </div>
          </Col>
          <Col md={3}>
            <h4 className="mb-3">Main Office</h4>
            <a href="mailto:sales@cap60.com" className="mb-3 d-block">
              sales@cap60.com
            </a>
            <a href="tel: 8183861081" className="mb-3 d-block">
              818.386.1081
            </a>
            <hr className="my-4" />

            <a href="mailto:sales@cap60.com d-block" className="textPebble">
              <Image src={contact} className="mr-2" />
              sales@cap60.com
            </a>
            <a href="tel: 8183861081" className="textPebble d-block mt-2">
              <Image src={mail} className="mr-2" />
              818.386.108
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ContactUs;
